import useSWR from 'swr';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';

import type { Vendor } from '../../types';
import { getCategoryMetadata } from '../../shared/helpers/categoryHelpers';
import svpApiClient from '../../services/svpApiClient';
import { SvpFilters } from '../../services/svp/filters';
import type { SvpEpisode } from '../../shared/helpers/assetHelpers';

export const useDefaultEpisode = ({
  category,
  vendor,
}: {
  category: SvpCategoryAdditional;
  vendor: Vendor;
}) => {
  return useSWR(`default_episode/${vendor}/${category.id}`, async () => {
    if (!category.isSeries) {
      return undefined;
    }

    const episodeSortingOrder =
      getCategoryMetadata(category).episodeSortingOrder?.value || 'asc';

    const {
      _embedded: { assets },
    } = await svpApiClient.searchAssets({
      vendor,
      limit: 1,
      filters: SvpFilters.from(`category.id::${category.id}`),
      sort: `series.seasonNumber|${episodeSortingOrder === 'asc' ? '-' : ''}series.episodeNumber`,
    });

    return assets[0] as SvpEpisode;
  });
};
